/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function PanelLeftOpen({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#PanelLeftOpen_svg__a)"><path fill="currentColor" d="M13.444.9c1.148 0 2.156.875 2.156 2.045v10.11c0 1.17-1.008 2.045-2.156 2.045H2.555c-.558 0-1.1-.206-1.508-.584a2 2 0 0 1-.647-1.46V2.944C.4 1.775 1.407.9 2.555.9zM2.555 2.1c-.57 0-.955.42-.955.845v10.11c0 .21.089.42.264.582.176.164.424.263.691.263h1.636V2.1zm2.836 11.8h8.053c.57 0 .956-.42.956-.845V2.945c0-.425-.386-.845-.956-.845H5.39z" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M10.346 6.303 12.043 8l-1.697 1.697M12.043 8H7.8" /></g><defs><clipPath id="PanelLeftOpen_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;